const U=v=>String(v||'').trim().toUpperCase();
const verified=r=>U(r?.verification_status)==='VERIFIED';

const ADVERSE=new Set(['NEGATIVE','DETERIORATING','WEAKENING','CONTRADICTS','DOWN','BEARISH','RISK']);
const SUPPORTIVE=new Set(['POSITIVE','IMPROVING','STRENGTHENING','SUPPORTS','UP','BULLISH']);

export function deriveWhyWrongEvidence(bundle={}){
 const demand=(Array.isArray(bundle?.demand)?bundle.demand:[]).filter(verified);
 const adverse=demand.filter(r=>ADVERSE.has(U(r?.evidence_direction)));
 const supportive=demand.filter(r=>SUPPORTIVE.has(U(r?.evidence_direction)));
 const unclassified=demand.filter(r=>!ADVERSE.has(U(r?.evidence_direction))&&!SUPPORTIVE.has(U(r?.evidence_direction)));

 const riskChecks=[];
 const mole=bundle?.moleEvidence||{};
 for(const f of Array.isArray(mole?.flags)?mole.flags:[])riskChecks.push({source:'MOLE',code:f.code||'RISK_FLAG',note:f.note||'Hidden-risk flag.'});
 if(U(bundle?.dogEvidence?.state)==='QUALITY_RISK')riskChecks.push({source:'DOG',code:'QUALITY_RISK',note:'Company Quality has multiple caution signals.'});
 if(['NEGATIVE_REPRICING','NEGATIVE_REVISION_DIVERGENCE'].includes(U(bundle?.rocketEvidence?.state)))riskChecks.push({source:'ROCKET',code:U(bundle?.rocketEvidence?.state),note:'Price/estimate repricing is negative.'});
 if(['MULTI_CROWDING','SHORT_CROWDED','HOLDER_CONCENTRATED','ELEVATED_CROWDING'].includes(U(bundle?.sheepEvidence?.state)))riskChecks.push({source:'SHEEP',code:U(bundle?.sheepEvidence?.state),note:'Verified crowding evidence is elevated.'});

 let state='OPEN';
 if(adverse.length)state='CONTRARY_EVIDENCE_PRESENT';
 else if(riskChecks.length)state='RISK_CHECKS_PRESENT';
 else if(unclassified.length)state='DIRECT_EVIDENCE_UNCLASSIFIED';
 else if(supportive.length)state='NO_CURRENT_CONTRARY_EVIDENCE';

 return{
  status:(demand.length||riskChecks.length)?'EVIDENCE':'MISSING',
  state,
  verifiedDemandRows:demand.length,
  contraryRows:adverse.length,
  supportiveRows:supportive.length,
  unclassifiedRows:unclassified.length,
  contraryEvidence:adverse.map(r=>({
   id:r.id||null,
   direction:U(r.evidence_direction)||'UNCLASSIFIED',
   claim:r.narrative_claim||r.narrative_key||null,
   evidenceType:r.evidence_type||null,
   sourceName:r.source_name||null,
   sourceRef:r.source_ref||null,
   observedAt:r.observed_at||r.as_of||null
  })),
  riskChecks,
  note:'WHY WRONG? distinguishes direct verified falsification evidence from contextual risk checks. Risk checks do not become thesis invalidation by themselves, and absence of contrary evidence does not confirm the thesis.'
 };
}
